const links = [
  {
    title: 'My Bookings',
    route: 'home',
    icon: 'HomeIcon',
    action: 'read',
    resource: 'Admin',// Customer
    noAdmin: true,
  },
  {
    title: 'Package Preparations',
    route: 'package-preparations',
    icon: 'InfoIcon',
    action: 'read',
    resource: 'Admin',// Customer
    noAdmin: true,
  },
  {
    title: 'Calendar',
    route: 'calendar',
    icon: 'CalendarIcon',
    action: 'manage',
    resource: 'Admin', // Company Owner
  },
  {
    title: 'Dashboards',
    icon: 'BarChart2Icon',
    action: 'manage',
    resource: 'Supervisor',
    children: [
      {
        title: 'Overview',
        route: 'admin',
        icon: 'LayoutIcon',
        action: 'manage',
        resource: 'Supervisor',
      },
      {
        title: 'Sales',
        route: 'dashboard-sales',
        icon: 'TrendingUpIcon',
        action: 'manage',
        resource: 'Company Owner',
      },
      {
        title: 'Returns',
        route: 'dashboard-returns',
        icon: 'RotateCcwIcon',
        action: 'manage',
        resource: 'Company Owner',
      },
      {
        title: 'Customers',
        route: 'dashboard-customers',
        icon: 'UsersIcon',
        action: 'manage',
        resource: 'Company Owner',
      },
      {
        title: 'Staff members',
        route: 'dashboard-staff',
        icon: 'UserCheckIcon',
        action: 'manage',
        resource: 'Company Owner',
      },
    ],
  },
  {
    title: 'Announcements',
    route: 'announcements',
    icon: 'AlertCircleIcon',
    action: 'manage',
    resource: 'Admin',
  },
  {
    title: window.companyPurpose === 'rent' ? "Bookings" : "Orders",
    icon: "ExternalLinkIcon",
    children: [
      {
        title: 'All ' + (window.companyPurpose === 'rent' ? "Bookings" : "Orders"),
        route: (window.companyPurpose === 'rent' ? 'bookings' : 'orders'),
        icon: 'BookIcon',
        action: 'manage',
        resource: 'Supervisor',
      },
      ...(window.companyPurpose !== 'rent' ? [{
        title: 'Orders with returns',
        route: 'returned_orders',
        icon: 'RotateCcwIcon',
        action: 'manage',
        resource: 'Company Owner',
      }] : []),
      {
        title: 'Repeating ' + (window.companyPurpose === 'rent' ? "Bookings" : "Orders"),
        route: (window.companyPurpose === 'rent' ? 'bookings' : 'orders')  + ('_repeat'),
        icon: 'RepeatIcon',
        action: 'manage',
        resource: 'Supervisor',
      },
      {
        title: 'Create ' + (window.companyPurpose === 'rent' ? "Booking" : "Order"),
        icon: 'PlusIcon',
        route: 'new-' + (window.companyPurpose === 'rent' ? "booking" : "order"),
        action: 'manage',
        resource: 'Supervisor',
        requiresStaffPermission: { subject: 'orders', ability: 'create' },
      },
    ]
  },
  {
    title: 'Inventory',
    icon: 'LayersIcon',
    children: [
      {
        title: 'Stock Locations',
        route: 'stockLocations',
        icon: 'LayersIcon',
        action: 'manage',
        resource: 'Supervisor',
      },
      {
        title: window.companyPurpose === 'rent' ? "Units" : "Products",
        route: window.companyPurpose === 'rent' ? "units" : "products",
        icon: 'LayersIcon',
        action: 'manage',
        resource: 'Supervisor',
      },
      {
        title: (window.companyPurpose === 'rent' ? "Unit" : "Product") + " Categories",
        route: (window.companyPurpose === 'rent' ? "unit" : "product") + "Categories",
        icon: 'LayersIcon',
        action: 'manage',
        resource: 'Supervisor',
      }
    ]
  },
  {
    title: 'Services',
    icon: 'ToolIcon',
    children: [
      {
        title: 'All services',
        route: 'services',
        icon: 'ToolIcon',
        action: 'manage',
        resource: 'Supervisor',
      },
      {
        title: 'Service categories',
        route: 'serviceCategories',
        icon: 'ToolIcon',
        action: 'manage',
        resource: 'Supervisor',
      },
    ],
  },
  {
    title: 'Company',
    icon: 'BriefcaseIcon',
    action: 'manage',
    resource: 'Company Owner',
    noAdmin: true,
    children: [
      {
        title: 'Staff members',
        route: 'staff',
        icon: 'UsersIcon',
        action: 'manage',
        resource: 'Company Owner',
      },
      {
        title: 'Suppliers',
        route: 'suppliers',
        icon: 'TruckIcon',
        action: 'manage',
        resource: 'Company Owner',
      },
      {
        title: 'Settings',
        route: 'company-settings',
        icon: 'SettingsIcon',
        action: 'manage',
        resource: 'Company Owner',
      },
      {
        title: 'Plan and Billing',
        route: 'plan-and-billing',
        icon: 'CreditCardIcon',
        action: 'manage',
        resource: 'Company Owner',
      },
    ],
  },
  {
    title: 'Companies',
    route: 'companies',
    icon: 'GridIcon',
    action: 'manage',
    resource: 'Admin',
  },
  {
    title: 'Packages',
    route: 'packages',
    icon: 'CompassIcon',
    action: 'manage',
    resource: 'Admin', // 'Company Owner'
  },
  {
    title: 'Customers',
    icon: 'UsersIcon',
    children: [
      {
        title: 'All Customers',
        route: 'customers',
        icon: 'UsersIcon',
        action: 'manage',
        resource: 'Supervisor'
      },
      {
        title: 'With repeating orders',
        icon: 'RepeatIcon',
        route: 'repeat-customers',
        action: 'manage',
        resource: 'Supervisor',
      }
    ]
  },
  {
    title: 'Staff',
    route: 'users',
    icon: 'BriefcaseIcon',
    action: 'manage',
    resource: 'Admin',
  },
  {
    title: 'Daily Log',
    route: 'daily-log',
    icon: 'Edit3Icon',
    action: 'manage',
    resource: 'Admin', // 'Supervisor'
    noAdmin: true,
  },

  {
    title: 'FAQ',
    icon: 'HelpCircleIcon',
    route: 'faq',
    action: 'read',
    resource: 'Admin',// Customer
    noAdmin: true,
  },
  /*{
    title: 'Announcement',
    icon: 'Volume2Icon',
    route: '#',
    modal: 'announcements-static-modal',
    action: 'read',
    resource: 'Customer',
    noAdmin: true,
  },*/
  {
    title: 'Profile',
    icon: 'UserIcon',
    route: 'profile',
    action: 'read',
    resource: 'Admin',// Customer
  }
]

export default links
